import styled from "styled-components";
import { Link } from "react-router-dom";
import breakpoints from "../../../styles/breakpoints";
import { fonts } from "../../../styles/variables";

// Typography and spacing mirror the wine galleries (molecules/WineGallery/style and
// molecules/WineGallerySection) so reward collections read the same as wine collections.
export const Gallery = styled.section`
  margin-bottom: 40px;

  ${breakpoints.smDown} {
    margin-bottom: 35px;
  }
  ${breakpoints.xsDown} {
    margin-bottom: 15px;
  }
`;

export const GalleryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
`;

export const GalleryHeading = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;

export const GalleryTitle = styled.h2`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 50px;
  margin: 0;

  ${breakpoints.smDown} {
    font-size: 25px;
  }
`;

export const GalleryActions = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SeeAll = styled(Link)`
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 14px;
  text-transform: uppercase;
  vertical-align: middle;
  padding-right: 15px;

  &:hover {
    text-decoration: underline;
  }
  ${breakpoints.smDown} {
    padding-right: 0;
  }
`;

export const GalleryItems = styled.div`
  display: flex;
  overflow-x: auto;
  margin: 20px -8px 0;

  ::-webkit-scrollbar {
    display: none;
  }

  > div {
    flex-shrink: 0;
  }
`;
